import { Timeline } from '@mui/lab';
import { Stack } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import SurveillanceItem from 'FRONTEND/components/Surveillance/SurveillanceItem';
import { selectSurveillanceDataForCurrentConsultation } from 'FRONTEND/reducers/consultationSlice';

// TODO: fet from Frontend Library instead
const SurveillanceTimeline = ({ showOrigin }) => {
  const surveillanceList = useSelector(selectSurveillanceDataForCurrentConsultation);

  if (surveillanceList.length === 0) {
    return;
  }
  return (
    <Stack sx={{ overflow: 'auto', scrollbarWidth: 0, alignItems: 'flex-start', width: '100%' }}>
      <Timeline sx={{ width: '80%' }}>
        {surveillanceList.map((surveillanceEvent, index) =>
          <SurveillanceItem
            key={index}
            surveillanceEvent={surveillanceEvent}
            showOrigin={showOrigin}
          />)}
      </Timeline>
    </Stack>
  );
};

export default SurveillanceTimeline;
